export { useIsNav4Enabled } from './useIsNav4Enabled';
export { getIsNav4Enabled } from './getIsNav4Enabled';

export const NAV_4_MAIN_CONTENT_ID = 'AkMainContent';
